import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Button} from 'views/components';

import {translate} from 'views/module';

import SubscribeUserDialog from '../dialogs/SubscribeUserDialog';
import {convertToE164} from 'utils/miscellaneous/e164';

const SmsDialpadIntegration = (props) => {
  const {clientBackend, relationshipData, smsData, statusProgressWrap: progressWrap} = props;
  const [isLoading, setIsLoading] = React.useState(false);
  const [showDialog, setShowDialog] = React.useState(false);
  const [smsNumber, setSmsNumber] = React.useState(smsData.smsNumber ?? '');

  React.useEffect(() => {
    setSmsNumber(smsData.smsNumber);
  }, [smsData.smsNumber]);

  const createDialpadLink = async (smsNumber) => {
    setIsLoading(true);
    progressWrap(async () => {
      const conversion = convertToE164(smsNumber);
      if (!conversion.isValid) {
        throw new Error(conversion.reasonNotValid || 'Invalid phone number');
      }
      const e164FormattedNumber = conversion.e164Format;
      const clientRelationshipRn = relationshipData.relationshipRn;
      const clientRn = clientRelationshipRn.split(':RELATIONSHIP')[0];
      await clientBackend.dialpadIntegration.createDialpadLink(
          clientRn,
          clientRelationshipRn,
          e164FormattedNumber,
          () => setIsLoading(false),
      );
    });
    setIsLoading(false);
  };

  const handleSubmitSmsNumber = (input) => {
    createDialpadLink(input);
    setShowDialog(false);
  };

  const handleOpenDialog = () => {
    setSmsNumber(smsNumber.trim());
    setShowDialog(true);
  };

  const getButtonConfig = () => {
    if (smsData.dialpadStatus === 'ACTIVE') {
      return {
        text: translate('client.ClientDetail.Relationships.Contacts.States.Active'),
        action: () => {/* no deactivation api right now */},
      };
    } else if (smsData.dialpadStatus === 'NOT_SET_UP') {
      return {text: translate('client.ClientDetail.Relationships.Contacts.States.Setup'), action: handleOpenDialog};
    } else {
      return;
    }
  };

  const buttonConfig = getButtonConfig();
  if (!buttonConfig) {
    return null;
  }
  return (
    <>
      <Button
        onClick={buttonConfig.action}
        variant='contained'
        size='small'
        disabled={isLoading}
        sx={{color: 'color.white'}}
      >
        {buttonConfig.text}
      </Button>
      {
        showDialog &&
        <SubscribeUserDialog
          open={showDialog}
          onClose={() => {
            setShowDialog(false);
          }}
          onSubmit={handleSubmitSmsNumber}
          initialChannelValue={smsNumber}
          isLoading={isLoading}
          channelType='Sms'
          channel='Dialpad'
          errorMessage={translate('client.ClientDetail.Relationships.Contacts.Dialogs.SmsHelperText.FailRegexMessage')}
          regex={/^\+?1?\s*(?:\(\d{3}\)|\d{3})[\s.-]?\d{3}[\s.-]?\d{4}$/}
        />
      }
    </>
  );
};

SmsDialpadIntegration.propTypes = {
  clientBackend: PropTypes.object.isRequired,
  smsData: PropTypes.shape({
    smsNumber: PropTypes.string.isRequired,
    dialpadStatus: PropTypes.string,
  }).isRequired,
  relationshipData: PropTypes.object.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, dispatch)(React.memo(SmsDialpadIntegration));
